export const CONSENT_VERSION = 1;
export const CONSENT_STORAGE_KEY = 'tippspiel_cookie_consent';

export const COOKIE_CATEGORIES = {
  necessary: {
    id: 'necessary',
    label: 'Notwendig',
    description: 'Erforderlich für Login, Tippspeicherung und diese Cookie-Einstellungen (z. B. JWT im Browser-Speicher).',
    required: true,
  },
  preferences: {
    id: 'preferences',
    label: 'Präferenzen',
    description: 'Merken sich optionale Darstellungs- und Komforteinstellungen.',
    required: false,
  },
  statistics: {
    id: 'statistics',
    label: 'Statistiken',
    description: 'Helfen uns zu verstehen, wie das Tippspiel genutzt wird (nur mit Einwilligung).',
    required: false,
  },
};

export const DEFAULT_CONSENT = {
  necessary: true,
  preferences: false,
  statistics: false,
};

export const CONSENT_UPDATED_EVENT = 'tippspiel-cookie-consent-updated';

export function readStoredConsent() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.version !== CONSENT_VERSION || !parsed?.categories) return null;
    return {
      version: parsed.version,
      timestamp: parsed.timestamp,
      categories: { ...DEFAULT_CONSENT, ...parsed.categories, necessary: true },
    };
  } catch {
    return null;
  }
}

export function hasConsentChoice() {
  return readStoredConsent() !== null;
}

export function saveConsent(categories) {
  const payload = {
    version: CONSENT_VERSION,
    timestamp: new Date().toISOString(),
    categories: { ...DEFAULT_CONSENT, ...categories, necessary: true },
  };
  localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(payload));
  window.dispatchEvent(new CustomEvent(CONSENT_UPDATED_EVENT, { detail: payload }));
  return payload;
}

export function acceptAllConsent() {
  return saveConsent({ necessary: true, preferences: true, statistics: true });
}

export function rejectOptionalConsent() {
  return saveConsent({ ...DEFAULT_CONSENT });
}

export function isCategoryEnabled(categoryId) {
  const stored = readStoredConsent();
  if (!stored) return categoryId === 'necessary';
  return Boolean(stored.categories[categoryId]);
}
